"use strict";
/* globals module */
/**
 * @module baasicArticleTagsSubscriptionsDefinition
 * @description  Article Tags Subscriptions Definition provides an easy way to consume  Article Tags REST API end-points. `articleTagsDefinition` functions enable performing standard CRUD operations directly on article tag resources, whereas the `articleClient` functions allow management between article and article tag. In order to obtain needed routes `articleTagsDefinition` uses `articleTagsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ArticleTagsSubscriptionsClient = /** @class */ (function () {
    function ArticleTagsSubscriptionsClient(articleTagsSubscriptionsRoute, apiClient) {
        this.articleTagsSubscriptionsRoute = articleTagsSubscriptionsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleTagsSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleTagsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action subscribes an user to the specified tag.
     * @method
     * @param tag article tag object.
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleTagsSubscriptionsClient.subscribe(tag, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleTagsSubscriptionsClient.prototype.subscribe = function (tag, data) {
        return this.apiClient.post(this.routeDefinition.subscribe(tag, data), this.routeDefinition.subscribeParams(tag, data));
    };
    /**
     * Returns a promise that is resolved once the isSubscribed action has been performed. This action checks if a user is subscribed to the specified tag.
     * @method
     * @param tag Article tag object.
     * @param data The subscriber identifier.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleTagsSubscriptionsClient.isSubscribed(tag, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleTagsSubscriptionsClient.prototype.isSubscribed = function (tag, data) {
        return this.apiClient.get(this.articleTagsSubscriptionsRoute.isSubscribed(tag, data));
    };
    /**
     * Returns a promise that is resolved once the unSubscribe action has been performed. This action unsubscribes a user from the specified tag.
     * @method
     * @param tag Article tag object.
     * @param data The unsubscribe information.
     * @returns A promise that is resolved once the unSubscribe action has been performed.
     * @example articleTagsSubscriptionsClient.unSubscribe(tag, user)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleTagsSubscriptionsClient.prototype.unSubscribe = function (tag, data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(tag, data), this.routeDefinition.subscribeParams(tag, data));
    };
    var _a, _b;
    ArticleTagsSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsSubscriptionsRoute !== "undefined" && _1.ArticleTagsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleTagsSubscriptionsClient);
    return ArticleTagsSubscriptionsClient;
}());
exports.ArticleTagsSubscriptionsClient = ArticleTagsSubscriptionsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/
